import { OrderStatus } from "@goodfill/domain-properties";

const STATUSES_AVAILABLE_FOR_KILL_OR_FILL = [
  OrderStatus.Open,
  OrderStatus.FillSubmittedToBroker,
  OrderStatus.ModifySubmittedToBroker,
  OrderStatus.FillAcknowledgedByBroker,
];

export function canKillOrFillOrder(orderTicket: { status: OrderStatus }) {
  return STATUSES_AVAILABLE_FOR_KILL_OR_FILL.includes(orderTicket.status);
}
